"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_USER_DEFAULT_TEXTS = void 0;
exports.CREATE_USER_DEFAULT_TEXTS = {
    formTitle: 'Create user',
    actionLogIn: 'Log in',
    labelLogin: 'Username:',
    labelPassword: 'Password:',
    labelPasswordConfirm: 'Repeat password:',
    labelRememberMe: 'Remain logged in',
    errorRequired: 'The field is required',
    errorMaxLength: 'The maximum length is {{length}}',
    errorPasswordDontMatch: 'Passwords do not match.',
    warningCapsLockOn: 'Caps Lock is on',
    helpTextPassword: 'Password should be at least 8 characters with one digit, one uppercase and one lowercase. Monotonic sequences such as 1234 are not allowed.'
};
//# sourceMappingURL=constants.js.map